import type { Props } from '..'
import type { ReactElement } from 'react'

const TitleIcon = ({ className, color, onClick, size }: Props): ReactElement => {
  return (
    <svg
      className={className}
      fill="none"
      height={size}
      onClick={onClick}
      role="icon"
      viewBox="0 0 21 21"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect fill={color} height="21" rx="5" width="21" />
      <path d="M9.54 16V7.15H6.06V5.5H14.97V7.15H11.49V16H9.54Z" fill="#E9E9E9" />
    </svg>
  )
}

export default TitleIcon
